import React from 'react';

export interface Message {
  type: string;
  payload: {
    [key: string]: any;
  };
}

interface UseIframePostMessageInput {
  message: Message | null;
}

interface UseIframePostMessageOutput {
  iframeRef: (node: HTMLIFrameElement) => void;
}

type UseIframePostMessage = ({ message }: UseIframePostMessageInput) => UseIframePostMessageOutput;

const useIframePostMessage: UseIframePostMessage = ({ message }) => {
  const [iframeEl, setIframeEl] = React.useState<HTMLIFrameElement>();

  const iframeRef = React.useCallback(node => {
    if (node) {
      setIframeEl(node);
    }
  }, []);

  React.useEffect(() => {
    const postMessage = () => {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      iframeEl?.contentWindow.postMessage(message, '*');
    };

    if (message) {
      iframeEl?.addEventListener('load', postMessage, false);
    }

    return () => {
      iframeEl?.removeEventListener('load', postMessage, false);
    };
  }, [iframeEl, message]);

  return {
    iframeRef,
  };
};

export default useIframePostMessage;
